import { NotificationContext } from '../context/NotificationContext';
import { useContext } from 'react';

export const useNotificationContext = () => {
  const context = useContext(NotificationContext);
  return context;
};